<template>

	<div class="row topic-video-list">

		<div class="col-xs-12">

			<div class="topic-video-body" v-show="!pager.loading">


				<div class="section-title" v-if="type === 'COURSE'">教学视频</div>
				<div class="section-title" v-if="type === 'LECTURE'">其他视频</div>
				<div v-for="video in pager.videos" :key="video">

					<div class="mv10 cursor hover-underline" @click.stop.prevent="video.click()">
						<i class="fa fa-video-camera"></i>
						{{video.name}}
					</div>

				</div>

			</div>

			<div class="mv20">
				<NbPager :pager="pager" :callback="refresh"/>
			</div>


		</div>


	</div>

</template>

<script>
	import NbPager from '../../../../common/widget/NbPager.vue'
	import NbTank from '../../../../common/widget/NbTank.vue'
	import Pager from  "../../../../common/model/base/Pager"
	import Video from  "../../../../common/model/video/Video"

	export default {
		data () {
			return {
				pager: new Pager(Video)

			}
		},
		props: {
			type: {
				type: String,
				required: false,
				"default"(){
					return Video.prototype.Type.COURSE;
				}
			}
		},
		computed: {

		},
		components: {
			NbTank,
			NbPager
		},
		watch: {
			'$route' (to, from) {
				if (to.path !== from.path) {
					this.reset();
					this.refresh();
				}
			}
		},
		methods: {
			reset(){

				this.pager.page = 0;
				this.pager.pageSize = 20;
				this.pager.resetFilter();
				this.pager.setFilter("type", this.type);
			},
			refresh(){
				this.pager.httpFastPage();
			}
		},
		mounted(){

			this.pager.enableHistory();
			this.reset();
			this.refresh();

		}
	}

</script>

<style lang="less" rel="stylesheet/less">


	.topic-video-list {

		.video-section {
			margin-bottom: 30px;
		}

		.section-title {
			font-size: 17px;
			color: #333;
			font-weight: bold;
			border-bottom: 1px solid #aaa;
			padding-bottom: 10px;
			margin-bottom: 10px;

		}

		.topic-video-body {

			padding: 40px;
			background-color: white;

			-webkit-border-radius: 5px;
			-moz-border-radius: 5px;
			border-radius: 5px;

		}
	}
</style>





// WEBPACK FOOTER //
// List.vue?5f42dd1e